var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"index-con"},[_c('el-aside',{class:_vm.showclass},[_c('leftnav')],1),_vm._v(" "),_c('el-container',{staticClass:"main-con"},[_c('el-header',{staticClass:"index-header"},[_c('navcon')],1),_vm._v(" "),_c('el-main',{attrs:{"clss":"index-main"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cad3417","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 